import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';
import * as React from 'react';
import { ReportsForm } from '@modules/reports/ReportsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const reportsUrl = '/metropolis/api/reports';
export const reportsLabel = 'Reporty';
export const reportsPath = '/reports';
export const reportsGridName = 'ReportsGrid';

export const ReportsGrid = compose(
  withRouter,
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: reportsLabel }]),
  withColumns(Agenda.REPORTS),
  withProps(({ columns }) => ({
    name: 'ReportsGrid',
    url: reportsUrl,
    Form: ReportsForm,
    dialog: false,
    gridProps: {
      columns,
      locale: 'cz',
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      adding: true,
      filtering: false,
      sort: 'name',
      pageSize: 50,
      version: 2,
      ActionBar: () => <ColumnManager agenda={Agenda.REPORTS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/reports/ReportsGrid.tsx